// note - this is a copy of the well-known from https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_C2hJ50cet/.well-known/jwks.json

export const jwksCache = {
    keys: [
        {
            alg: "RS256",
            e: "AQAB",
            kid: "c6nmhkL4qlKODtlEE3vuhKN3SB7aO6TsoNqa7W8uzzU=",
            kty: "RSA",
            n: "5jDDczdR8xR_Tf7r-KYC5D08qOU1tUWricQLEfGSikJL90I8_OQozAlpAbfvqWbHnOCiR9RyiwJm8RvjUerNqwFOwjpiHeKQ5KOXfzAZHIg4CujV_hgBdGGvksy_jk6_5j7ESXYX76L_fP2KATSS6NlHNPkFxTSEMo3zhPSgAb1n9KcVd44PkGpco27j-W4iXH2dPaeaml7lioGX5UYoWhByROAq25-HvLO6NsSd_8AkRtcrEkonBW7XG-U9e2D8f5R3MYa_3cC9dnCE2MvxjUcWTpntUwGIYih6hjHUrVrVdygsvbTJrL7DF_bg9Er5kPZXR6QkbvF9gZuOFWRCCQ",
            use: "sig",
        },
        {
            alg: "RS256",
            e: "AQAB",
            kid: "uyOeQr+f9Ldog4qyQLKl/y7jmNAEke9jLHou0uMf59w=",
            kty: "RSA",
            n: "rvZxjVy-7FCMfdK5tbvYa6XwKKldX6UQEvUVjSYwSi7V0FDgx35sr_cPLb9LfS002FhNg7qTK-FE-Jbpm4DkATUdAJB8pLEkUBXFfH32MaG6tfC94tDpjUu-JSk3NJRdShA61EQNT3700z3r9r1ftj34Fnb1iElojVpqvAWka8vRGxZpW3Xy6Qgrrm2NDFO4TK8mAdPyGfD6l1sqKK1zScSXHqxjUg6YL3-sO6N-kWq8K4OPjjygWZSyN8JX_1pMdq5juaSntTwezxQDOrFE9VyOe2gcngR6pQjPKH7lgLUBFAyfFQOuUoaGXf_03hu2EUU3iMhS3PsGRderNQ88nw",
            use: "sig",
        },
    ],
}
